export default __webpack_public_path__ + "static/media/cesto_uve.c8eaa197.svg";